import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, forkJoin } from 'rxjs';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { MediaModel } from '../models/media.model';
import { MediasService } from '../../../../../services/medias.service';
import { EventType } from '../../../../../shared/interfaces/event.model';
import { CategoryService } from '../../../../../services/category.service';
import { CustomersService } from '../../../../../services/customers.service';

@Component({
	selector: 'app-edit-create-media',
	templateUrl: './edit-create-media.component.html',
	styleUrls: ['./edit-create-media.component.scss']
})
export class EditCreateMediaComponent implements OnInit {
	@Input() data: any = {};
	formGroup: RxFormGroup;
	isEdit = false;
	fields: any = {
		title: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Titulo',
					class: 'col-sm-12'
				}
			}
		},
		description: {
			type: 'textarea',
			options: {
				path: 'description',
				class: 'col-sm-12',
				label: {
					text: 'Descripcion',
					class: 'col-sm-12'
				}
			}
		},
		resource: {
			type: 'media',
			options: {
				path: 'resource',
				class: 'col-sm-12',
				label: {
					text: 'Publicidad',
					class: 'd-none'
				},
				image: {
					src: null
				},
				allowedTypes: 'video/*'
			}
		},
		categories: {
			type: 'multiselect',
			options: {
				path: 'categories',
				label: {
					text: 'Categorías',
				},
				options: [],
				optionLabel: 'name',
				optionValue: 'id',
				multiple: true
			}
		},
		client_id: {
			type: 'select',
			options: {
				path: 'client_id',
				label: {
					text: 'Cliente'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		}, fecha: {
			type: 'datepicker',
			options: {
				path: 'fecha',
				label: {
					text: 'Fecha de Inicio',
				},
				placeholder: 'dd/mm/aaaa'
			}
		},
		vigencia: {
			type: 'datepicker',
			options: {
				path: 'vigencia',
				label: {
					text: 'Fecha de Vigencia',
				},
				placeholder: 'dd/mm/aaaa'
			}
		}

	};

	isAdmin: boolean = false;

	private atComponentDestroy = new Subject();




	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private mediaService: MediasService,
		private categoryService: CategoryService,
		private customersService: CustomersService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(form => {
				this.formGroup = form;
				this.cdr.detectChanges();
			});
	}
	

	async ngOnInit(): Promise<void> {
		this.formService.transformIntoFormGroup(MediaModel, this.data.item ?? {});
		let categoriesResponse = await this.categoryService.getAll();
		let clientsResponse = await this.customersService.getAll();
		this.isAdmin = this.data?.IsAdmin || false;
		let categories = categoriesResponse.data ?? [];
		let clients = clientsResponse.data ?? [];
		
		categories = categories.map(data => ({ id: data.id, name: data.name }));
		clients = clients.map(data => ({ id: data.id, name: data.name }));
		
		this.fields.categories.options.options = [...categories];
		this.fields.client_id.options.dropdown.options = [...clients];
		if (this.data?.item.id && Array.isArray(this.data.item.categories)) {
			const selectedCategoryIds = this.data.item.categories.map(cat => typeof cat === 'object' ? cat.id : cat);
			this.formGroup.get('categories')?.setValue(selectedCategoryIds);
			this.formGroup.get('fecha')?.setValue(this.data.item.fecha);
			this.formGroup.get('vigencia')?.setValue(this.data.item.vigencia);

		}

		if (this.data?.item.id) {
			this.isEdit = true;
			this.data.name = this.data.title;
			this.formGroup.get('name')?.setValue(this.data.item.name);
			this.formGroup.get('description')?.setValue(this.data.item.description);
			
		}
		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.cdr.markForCheck();
			});
	}


	/**
	 * Send the data to the server
	 */
	submit(): void {
		this.mediaService.createOrUpdate(this.formGroup, this.data?.item.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.broadcast.reloadDataTable();
				this.modalRef.hide();
			}, error => {
				console.error("Error al enviar los datos:", error);
			});
	}

	/**
	 * Transform and object into an array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}
	

}
